<template>
  <b-card id="dynamic-table" class="container-card">
    <div class="d-flex justify-content-end align-items-center">
      <filter-header-table
        :pagination="pagination"
        :on-select-entities="onSelectEntities"
        :on-search="onSearch"
        :search-value="searchValue"
        :is-create="isCreate"
        :displayed-columns="displayColumnOptions.options"
        :filter-columns="dynamicTable.filterColumn"
        :on-select-filter="onSelectFilter"
        @optionSelected="editDisplayList"
        class="mr-2"
      />
      <view-data-button
        class="mr-4"
        :isViewed="isVerified"
        @onViewData="confirmViewData"
        v-if="dynamicTable.payload.length"
      />
    </div>
    <overlay-loading :loading="loading.tableData">
      <template #content>
        <b-table
          :key="keyChange"
          v-sortable-col="sortableColOptions"
          :items="dynamicTable.payload"
          :fields="dynamicTable.column"
          responsive
          bordered
          borderless
          sticky-header
          show-empty
          no-local-sorting
          class="dynamic-table"
          :class="!sortableColOptions.disabled ? 'column-sortable' : null"
          @sort-changed="sortingChanged"
        >
          <template
            v-for="col in dynamicTable.column"
            v-slot:[renderHead(col.key)]
          >
            <span :key="col.key + 'head'" class="dynamic-head-table-custom">{{
              $i18n.locale == "th" ? col.label_th : col.label_en
            }}</span>
          </template>
          <template
            v-for="col in dynamicTable.column"
            v-slot:[renderCell(col.key)]="data"
          >
            <component
              :is="data.field.type_desc"
              :key="col.key"
              :column-properties="data"
            />
            
          </template>
          <template #table-busy>
            <overlay-loading :loading="true" />
          </template>
          <template #empty>
            <card-no-item :text-no-img="'Item Not Found'" />
          </template>
        </b-table>
      </template>
    </overlay-loading>
    <div class="m-2">
      <pagination-with-reorder
        entity-editable
        :pagination="pagination"
        @entityChange="onFilterEntity"
        @pageChange="onPageChange"
      />
    </div>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BTable, BSpinner } from "bootstrap-vue";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import Sortable from "sortablejs";
import ImageColumn from "./components/ImageColumn.vue";
import TextColumn from "./components/TextColumn.vue";
import DateColumn from "./components/DateColumn.vue";
import ActionColumn from "./components/ActionColumn.vue";
import OptionColumn from "./components/OptionColumn.vue";
import FilterHeaderTable from "../filter-header-table/FilterHeaderTable.vue";
import Pagination from "../pagination/Pagination.vue";
import useDynamicTable from "./hooks/useDynamicTable";
import PaginationWithReorder from "../pagination/PaginationWithReorder.vue";
import ViewDataButton from "../button/ViewDataButton.vue";

const createSortable = (el, options, vnode) =>
  Sortable.create(el, {
    ...options,
  });

// const sortableRow = {
//   name: 'sortableRow',
//   bind(el, binding, vnode) {
//     const table = el;
//     table._sortable = createSortable(
//       table.querySelector('tbody'),
//       binding.value,
//       vnode
//     );
//   },
// };

const sortableCol = {
  name: "sortableCol",
  bind(el, binding, vnode) {
    const table = el;

    table._sortable = createSortable(
      table.querySelector("tr"),
      binding.value,
      vnode
    );
  },
};

export default {
  directives: {
    Ripple,
    // sortableRow,
    sortableCol,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BTable,
    BSpinner,
    ImageColumn,
    TextColumn,
    DateColumn,
    ActionColumn,
    OptionColumn,
    FilterHeaderTable,
    vSelect,
    CardNoItem,
    PaginationWithReorder,
    Pagination,
    ViewDataButton,
  },
  props: {
    displayKey: String,
    queryDataKey: String,
    queryId: Number,
    displayId: Number,
    isCreate: Boolean,
  },
  setup(props) {
    const {
      loading,
      dynamicTable,
      pagination,
      paginationInfo,
      searchValue,
      displayColumnOptions,
      sortableRowOptions,
      sortableColOptions,
      keyChange,
      renderCell,
      renderHead,
      onSelectEntities,
      onSearch,
      sortingChanged,
      editDisplayList,
      onSelectFilter,
      onFilterEntity,
      onPageChange,
      confirmViewData,
      isVerified,
    } = useDynamicTable(props);

    return {
      loading,
      dynamicTable,
      pagination,
      paginationInfo,
      searchValue,
      displayColumnOptions,
      keyChange,
      sortableRowOptions,
      sortableColOptions,
      renderCell,
      renderHead,
      onSelectEntities,
      onSearch,
      sortingChanged,
      editDisplayList,
      onSelectFilter,
      onFilterEntity,
      onPageChange,
      confirmViewData,
      isVerified,
    };
  },
};
</script>

<style>
@import "~@/assets/css/pages/dynamic-tables.css";
</style>
